import axios from 'axios';

export default{
  // 能源走势
  //能源走势保存
  saveOrUpdateBatch(data) {
    return axios.post('/energy/trend/saveOrUpdateBatch',data);
  },
  //能源走势日数据保存
  saveTrendDaySave(data) {
    return axios.post('/energy/trend/trendDaySave',data);
  },
  //获取能源走势日数据
  getTrendDayList() {
    return axios.get('/energy/trend/trendDayList');
  },
  //获取能源走势
  getBatch(data) {
    return axios.get('/energy/trend/list2?collect='+data.collect+'&type='+data.type+'&dataTime='+data.time);
  },
  
  
  //能源结构
  //能源结构保存
  saveStructure(data) {
    return axios.post('/energy/structure/save',data);
  },
  //获取能源结构
  getStructure() {
    return axios.get('/energy/structure/mine');
  },

  //重点用能设备
  //重点用能设备保存
  saveImpDev(data) {
    return axios.post('/energy/capital/save',data);
  },
  //重点用能设备修改
  upDateImpDev(data) {
    return axios.put('/energy/capital/update',data);
  },
  //获取重点用能设备数据列表1
  getImpDevList(data) {
    return axios.get('/energy/capital/list',data);
  },
  //获取重点用能设备数据列表2
  getImpDevList2(data) {
    return axios.get('/energy/capital/list2',data);
  },
  //获取重点用能设备详情
  getImpDevDetail(id) {
    return axios.get('/energy/capital/info/'+id);
  },
  //删除重点用能设备
  delImpDev(data) {
    return axios.delete('/energy/capital/delete?id='+data);
  },

  //安全提示
  //安全提示保存id
  saveSafaty(data) {
    return axios.post('/energy/notify/saveOrUpdateBatch',data);
  },
  //获取安全提示数据
  getSafaty() {
    return axios.get('/energy/notify/list');
  },
  //获取安全提示数据
  getSafatyInfo(data) {
    return axios.get('/energy/notify/info/'+data);
  },
  //删除安全提示数据
  delSafaty(data) {
    return axios.post('/energy/notify/delete',data);
  },


  //实时状态
  //保存组态
  saveConf(data) {
    return axios.post('/energy/conf/save',data);
  },
  //获取数据
  getConf() {
    return axios.get('/energy/conf/list');
  },


  //全年碳排放指标
  //保存指标
  saveCarbon(data) {
    return axios.post('/energy/carbon/save',data);
  }, 
  //获取指标
  getCarbon(data) {
    return axios.get('/energy/carbon/list',data);
  },


  //减排进度及趋势
  //保存减排进度及趋势
  saveReduction(data) {
    return axios.post('/energy/reduction/saveOrUpdateBatch',data);
  }, 
  //获取减排进度及趋势
  getReduction() {
    return axios.get('/energy/reduction/list');
  }, 
  //删除趋势
  delReduction(data) {
    return axios.post('/energy/reduction/delete',data);
  },



  
  //能源优化投入
  //保存优化投入
  saveInput(data) {
    return axios.post('/energy/input/saveOrUpdateBatch',data);
  },
  //获取优化投入
  getInput(data) {
    return axios.get('/energy/input/yearInput?year='+data.year);
  }, 
  getInputZB() {
    return axios.get('/energy/input/list');
  }, 
  //删除优化投入
  delInput(data) {
    return axios.post('/energy/input/delete',data);
  },



  //能源优化成效
  //保存优化成效
  saveIncome(data) {
    return axios.post('/energy/income/save',data);
  },
  //获取优化成效
  getIncome(data) {
    return axios.get('/energy/income/yearIncom?year='+data.year);
  }, 
  getIncomeZB() {
    return axios.get('/energy/income/list');
  }, 
  //删除优化成效
  delIncome(data) {
    return axios.post('/energy/income/delete',data);
  },


  //能源指标
  //保存能源指标
  saveTarget(data) {
    return axios.post('/energy/target/save',data);
  },  
  //获取能源指标
  getTarget(data) {
    return axios.get('/energy/target/list',data);
  },
  
  

  //行业对标
  //保存行业对标
  saveBench(data) {
    return axios.post('/energy/bench/save',data);
  },  
  //获取行业对标
  getBench() {
    return axios.get('/energy/bench/list');
  },  
  
  

  //能源损耗
  //保存能源损耗
  saveLoss(data) {
    return axios.post('/energy/loss/save',data);
  },  
  //获取能源损耗
  getLoss() {
    return axios.get('/energy/loss/list');
  },  
  
  

  //投产比
  //保存投产比
  saveProratio(data) {
    return axios.post('/energy/proratio/save',data);
  },  
  //获取投产比
  getProratio() {
    return axios.get('/energy/proratio/list');
  },  
  
  //昨日用能
  //保存昨日用能
  saveLastUse(data) {
    return axios.post('/energy/lastUse/save',data);
  },  
  //获取昨日用能
  getLastUse() {
    return axios.get('/energy/lastUse/list');
  },  


  //采集设备在线率
  //保存采集设备在线率
  saveDevLine(data) {
    return axios.post('/energy/dev/line/save',data);
  },  
  //获取采集设备在线率
  getDevLine() {
    return axios.get('/energy/dev/line/list');
  },  

  //变压器负载
  //保存变压器负载
  saveDevLoad(data) {
    return axios.post('/energy/dev/load/save',data);
  },  
  //获取变压器负载
  getDevLoad() {
    return axios.get('/energy/dev/load/list');
  },
  //删除变压器负载
  delDevLoad(id) {
    return axios.delete('/energy/dev/load/delete?id='+id);
  },

  //本月需量分析
  //保存本月需量分析
  saveNeedData(data) {
    return axios.post('/energy/need/data/save',data);
  },  
  //获取本月需量分析
  getNeedData() {
    return axios.get('/energy/need/data/list');
  },  
}